import BigNumber from 'bignumber.js/bignumber';

import EGLD from 'assets/img/coins/egld.png';
import WEGLD from 'assets/img/coins/wegld.png';
import USDC from 'assets/img/coins/usdc.png';
import AERO from 'assets/img/coins/aero.png';
import ASH from 'assets/img/coins/ash.png';
import BHAT from 'assets/img/coins/bhat.png';
import CRT from 'assets/img/coins/crt.png';
import CRU from 'assets/img/coins/cru.png';
import EFFORT from 'assets/img/coins/effort.png';
import ISET from 'assets/img/coins/iset.png';
import ITHEUM from 'assets/img/coins/itheum.png';
import MEX from 'assets/img/coins/mex.png';
import QWT from 'assets/img/coins/qwt.png';
import RIDE from 'assets/img/coins/ride.png';
import UTK from 'assets/img/coins/utk.png';
import WAM from 'assets/img/coins/wam.png';
import ZPAY from 'assets/img/coins/zpay.png';
import ONE from 'assets/img/coins/one.png';
import UNKNOWN from 'assets/img/coins/unknown.png';
import { isDev } from 'config/config';

export const BigZero = new BigNumber(0);
export const BigMax = new BigNumber('Infinity');

export const coinNames = isDev ? 
    [
        'EGLD',
        'WEGLD-d7c6bb',
        'USDC-8d4068',
        'MEX-dc289c',
        'ASH-4ce444',
        'RIDE-6e4c49',
        'ITHEUM-a61317',
        'UTK-b90622',
        'CRT-1beb53',
        'ONE-429c7d',
        'unknown'
    ]: [
        'EGLD',
        'WEGLD-bd4d79',
        'USDC-c76f1f',
        'MEX-455c57',
        'ASH-a642d1',
        'RIDE-7d18e9',
        'ITHEUM-df6f26',
        'utk-2f80e9',
        'crt-52decf',
        'cru-a5f4aa',
        'zpay-247875',
        'bhat-c1fde3',
        'qwt-46ac01',
        'iset-84e55e',
        'aero-458bbf',
        'effort-a13513',
        'wam-510e42',
        'unknown',
    ];

interface CoinImageType {
    [key: string]: string
}

export const coins: CoinImageType =
    isDev ? {   
        'EGLD': EGLD,
        'WEGLD-d7c6bb': WEGLD,
        'USDC-8d4068': USDC,
        'MEX-dc289c': MEX,
        'ASH-4ce444': ASH,
        'RIDE-6e4c49': RIDE,
        'ITHEUM-a61317': ITHEUM,
        'UTK-b90622': UTK,
        'CRT-1beb53': CRT,
        'ONE-429c7d': ONE,
        'unknown': UNKNOWN,
    } : {
        'egld': EGLD,
        'wegld-bd4d79': WEGLD,
        'usdc-c76f1f': USDC,
        'mex-455c57': MEX,
        'ash-a642d1': ASH,
        'ride-7d18e9': RIDE,
        'itheum-df6f26': ITHEUM,
        'utk-2f80e9': UTK,
        'crt-52decf': CRT,
        'cru-a5f4aa': CRU,
        'zpay-247875': ZPAY,
        'bhat-c1fde3': BHAT,
        'qwt-46ac01': QWT,
        'iset-84e55e': ISET,
        'aero-458bbf': AERO,
        'effort-a13513': EFFORT,
        'wam-510e42': WAM,
        'unknown': UNKNOWN,
    };